import { render, staticRenderFns } from "./StockEditDesktop.vue?vue&type=template&id=0f56d176"
import script from "./StockEditDesktop.vue?vue&type=script&lang=ts"
export * from "./StockEditDesktop.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f56d176')) {
      api.createRecord('0f56d176', component.options)
    } else {
      api.reload('0f56d176', component.options)
    }
    module.hot.accept("./StockEditDesktop.vue?vue&type=template&id=0f56d176", function () {
      api.rerender('0f56d176', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/stock/StockEditDesktop.vue"
export default component.exports